/**
 * UFC delivery display — PT billing Tuesday anchor + 3 days = Friday.
 * delivery:MM/DD tags are the delivery calendar date (Friday).
 */
(function (global) {
  var DELIVERY_DAYS_AFTER_ANCHOR = 3;

  function parsePacificNoonFromIso(iso) {
    if (!iso) return null;
    var s = String(iso).trim();
    if (/^\d{4}-\d{2}-\d{2}/.test(s)) {
      return new Date(s.slice(0, 10) + 'T12:00:00Z');
    }
    var d = new Date(s);
    if (isNaN(d.getTime())) return null;
    var ymd = d.toLocaleDateString('en-CA', { timeZone: 'America/Los_Angeles' });
    return new Date(ymd + 'T12:00:00Z');
  }

  /** Anchor billing instant to PT calendar Tuesday (renewal: most recent Tue), then +3 → Friday. */
  function billingTuesdayToDeliveryPacific(billingIso) {
    var ptNoon = parsePacificNoonFromIso(billingIso);
    if (!ptNoon) return null;
    var ptDay = ptNoon.getUTCDay();
    var daysBackToTue = (ptDay - 2 + 7) % 7;
    var anchor = new Date(ptNoon);
    anchor.setUTCDate(anchor.getUTCDate() - daysBackToTue);
    var ship = new Date(anchor);
    ship.setUTCDate(ship.getUTCDate() + DELIVERY_DAYS_AFTER_ANCHOR);
    return ship;
  }

  /** Parse delivery tag / ISO — PT noon on that calendar date (no weekday shift). */
  function parseDeliveryTagDatePacific(input) {
    var dt;
    if (input instanceof Date) {
      dt = new Date(input.getTime());
    } else if (typeof input === 'number') {
      dt = new Date(input * 1000);
    } else {
      dt = parsePacificNoonFromIso(input);
    }
    if (!dt || isNaN(dt.getTime())) return null;
    return dt;
  }

  function normalizeTagIsoToUnixSec(iso) {
    if (!iso) return null;
    var d = parseDeliveryTagDatePacific(iso);
    if (!d) return null;
    return Math.floor(d.getTime() / 1000);
  }

  function formatLongPacific(date) {
    if (!date || isNaN(date.getTime())) return '';
    return date.toLocaleDateString('en-US', {
      weekday: 'long',
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      timeZone: 'America/Los_Angeles',
    });
  }

  function deliveryDaysAfterAnchor() {
    return DELIVERY_DAYS_AFTER_ANCHOR;
  }

  global.UfcDeliveryDate = {
    billingTuesdayToDeliveryPacific: billingTuesdayToDeliveryPacific,
    parseDeliveryTagDatePacific: parseDeliveryTagDatePacific,
    normalizeTagIsoToUnixSec: normalizeTagIsoToUnixSec,
    formatLongPacific: formatLongPacific,
    deliveryDaysAfterAnchor: deliveryDaysAfterAnchor,
  };
})(typeof window !== 'undefined' ? window : globalThis);
